import { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import CanonicalTag from '../components/CanonicalTag';
import therapyOfficeImage from '../assets/therapy-office-adu.jpg';

const HowToUseADUTherapyOffice = () => {
  const [showCalendly, setShowCalendly] = useState(false);

  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);
  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/how-to-use-adu-as-therapy-office-or-healing-space" />
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="pt-24 pb-16">
          <div className="container mx-auto px-6">
            {/* Hero Section */}
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
                How to Use Your ADU as a Therapy Office or Healing Practice Room
              </h1>
              <div className="flex justify-center mb-8">
                <button 
                  onClick={openCalendlyModal}
                  className="bg-brand-orange text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-orange/90 transition-colors"
                >
                  📅 Book & Schedule
                </button>
              </div>
            </div>

            {/* Main Image */}
            <div className="mb-16">
              <img 
                src={therapyOfficeImage} 
                alt="Therapy Office ADU" 
                className="w-full h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content Sections */}
            <div className="space-y-16">
              {/* Section 1 */}
              <section>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#E4683B' }}>
                  Create a Confidential, Comfortable Healing Environment
                </h2>
                <p className="text-lg text-muted-foreground mb-8">
                  Therapists, coaches, and bodyworkers can use a private ADU as a tranquil and professional setting for 1-on-1 or virtual sessions.
                </p>
                
                <div className="grid md:grid-cols-3 gap-6 mb-8">
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Privacy & Comfort</h3>
                    <p className="text-muted-foreground">Soundproofed walls and calming atmosphere for confidential sessions</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Professional Setup</h3>
                    <p className="text-muted-foreground">Separate entrance, comfortable seating, and healing-focused design</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Therapeutic Design</h3>
                    <p className="text-muted-foreground">Natural lighting, calming colors, and plants for a peaceful environment</p>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row gap-4 justify-center">
                  <button 
                    onClick={() => window.location.href = '/landing'}
                    className="bg-white text-brand-orange border-2 border-brand-orange px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange hover:text-white transition-colors"
                  >
                    📐 What Fits My Lot?
                  </button>
                  <button 
                    onClick={() => window.location.href = '/adu-calculator'}
                    className="bg-brand-orange text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange/90 transition-colors"
                  >
                    💰 Get Your Price & ROI Report
                  </button>
                </div>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#E4683B' }}>
                  Built for Emotional and Energetic Comfort
                </h2>
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-2xl font-semibold mb-4" style={{ color: '#E4683B' }}>Design Features</h3>
                    <ul className="space-y-3 text-muted-foreground">
                      <li>• Soundproofed walls and floors</li>
                      <li>• Soft daylight and calming wall tones</li>
                      <li>• Sofa + client seating zone</li>
                      <li>• Treatment table or therapy corner</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-2xl font-semibold mb-4" style={{ color: '#E4683B' }}>Perfect For:</h3>
                    <ul className="space-y-3 text-muted-foreground">
                      <li>• Psychologists, marriage counselors</li>
                      <li>• Reiki practitioners, energy healers</li>
                      <li>• Speech therapists or virtual coaching pros</li>
                      <li>• Wellness and holistic health practitioners</li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#E4683B' }}>
                  Professional Practice Benefits
                </h2>
                <p className="text-lg text-muted-foreground mb-8">
                  A dedicated healing space provides the professional environment needed for successful therapeutic practice.
                </p>
                
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Client Comfort</h3>
                    <p className="text-muted-foreground">Calming environment with sage green tones and natural elements</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Business Benefits</h3>
                    <p className="text-muted-foreground">Separate workspace from home with tax-deductible business space</p>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-6">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#E4683B' }}>Flexible Use</h3>
                    <p className="text-muted-foreground">Perfect for in-person sessions, virtual coaching, or group workshops</p>
                  </div>
                </div>
              </section>
            </div>

            {/* Bottom CTAs */}
            <div className="text-center mt-16">
              <div className="flex flex-col md:flex-row gap-4 justify-center">
                <button 
                  onClick={() => window.open('/our-work', '_blank')}
                  className="bg-white text-brand-orange border-2 border-brand-orange px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange hover:text-white transition-colors"
                >
                  🏡 Our Portfolio
                </button>
                <button 
                  onClick={() => window.open('https://uda-adu.com/faq', '_blank')}
                  className="bg-brand-orange text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange/90 transition-colors"
                >
                  ❓ Our FAQ
                </button>
              </div>
            </div>
          </div>
        </main>

        <Footer />

        {/* Calendly Modal */}
        {showCalendly && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl h-[90vh] m-4">
              <div className="flex justify-between items-center p-4 border-b">
                <h3 className="text-lg font-semibold">Schedule a Consultation</h3>
                <button 
                  onClick={closeCalendlyModal}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ✕
                </button>
              </div>
              <iframe 
                src="https://calendly.com/udaadu"
                width="100%" 
                height="100%" 
                frameBorder="0"
                title="Schedule a meeting"
                className="rounded-b-lg"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HowToUseADUTherapyOffice;